import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Download = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color || 'none'}
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke || 'currentColor'}
      {...props}
    >
      <path d="M4 6.5L8 10.5M8 10.5L12 6.5M8 10.5V2M2 13.5H14" />
    </svg>
  ),
)
Download.displayName = 'Download'

export default Download
